//设置sessionStorage
export function sessionStorageSet(key, value) {
    const obj = {
        data: value
    }
    sessionStorage.setItem(key, JSON.stringify(obj))
}
//获取sessionStorage
export function sessionStorageGet(key) {
    const storage = sessionStorage.getItem(key)

    let result = null;
    if (storage) {
        const obj = JSON.parse(storage) || {}
        result = obj.data
    }
    return result
}